import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { RowComponent } from 'core-ui';

@Component({
  imports: [RouterOutlet, RowComponent],
  selector: 'wpp-plan-appointment',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './plan-appointment.html',
})
export class PlanAppointmentPage {}
